module.exports = __webpack_public_path__ + "static/media/backing.7d401314.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/backing.svg
// module id = 92
// module chunks = 0